module.exports = __webpack_public_path__ + "img/rec-main-downArrow.d0332e92.svg";